/* eslint-disable */

/** unique or primary key constraints on table "argo.schedule_day" */
export enum ArgoScheduleDayConstraint {
  /** unique or primary key constraint on columns "day" */
  ScheduleDayPkey = 'schedule_day_pkey'
}

export enum ArgoScheduleDayEnum {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

/** select columns of table "argo.schedule_day" */
export enum ArgoScheduleDaySelectColumn {
  /** column name */
  Day = 'day',
  /** column name */
  Description = 'description'
}

/** update columns of table "argo.schedule_day" */
export enum ArgoScheduleDayUpdateColumn {
  /** column name */
  Day = 'day',
  /** column name */
  Description = 'description'
}

